/** Oyunun sabit kuralları. Hem sunucu hem istemci buradan okur. */
export const WORD_LENGTH = 5;
export const MAX_ATTEMPTS = 6;
/** Kuyruk maçları ve eski istemciler için değişmeyen standart kurallar. */
export const STANDARD_DUEL_RULES = Object.freeze({
    durationMinutes: 3,
    maxAttempts: 6,
    victoryRule: "fewest-attempts",
    pressureEnabled: true,
});
/** Düello süresi (ms). Plan: 3 dakika. */
export const DUEL_DURATION_MS = STANDARD_DUEL_RULES.durationMinutes * 60_000;
/** Maç bulunduktan sonra tahta açılmadan önceki geri sayım (ms). */
export const DUEL_COUNTDOWN_MS = 3_000;
/**
 * Arkadaşa gönderilen meydan okumanın geçerlilik süresi (ms).
 *
 * Kısa tutuluyor: davet bir maç çağrısı, karşı taraf o an başındaysa anlamı var.
 * Süre dolunca davet düşer ve gönderen yeniden davet edebilir — aynı süre boyunca
 * "Meydan oku" düğmesi de kapalı kalır, arka arkaya davet yağdırılamasın.
 */
export const CHALLENGE_TTL_MS = 5 * 60_000;
/** Gönderen daveti iptal edince aynı arkadaşa yeniden gönderme aralığı. */
export const CHALLENGE_CANCEL_COOLDOWN_MS = 10_000;
/** The first rename is immediate; subsequent renames use the last change time. */
export const USERNAME_CHANGE_COOLDOWN_MS = 90 * 24 * 60 * 60_000;
/** Günlük kelimenin gün sınırı — Türkiye saatine göre gece yarısı. */
/** @deprecated Edition-aware code should use `editionRules(id).timeZone`. */
export const GAME_TIMEZONE = "Europe/Istanbul";
/**
 * Ekran klavyesi düzeni: Türkçe Q klavyeden Q/W/X çıkarılmış hâli.
 * Toplam 29 harf — Türk alfabesinin tamamı.
 */
/** @deprecated Edition-aware code should use `editionRules(id).keyboardRows`. */
export const KEYBOARD_ROWS = [
    ["E", "R", "T", "Y", "U", "I", "O", "P", "Ğ", "Ü"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ş", "İ"],
    ["BACKSPACE", "Z", "C", "V", "B", "N", "M", "Ö", "Ç", "ENTER"],
];
/** Sonuç paylaşımında kullanılan kareler. */
export const EMOJI = {
    correct: "🟩",
    present: "🟨",
    absent: "⬛",
};
//# sourceMappingURL=constants.js.map